export default __webpack_public_path__ + "static/integrations_shopifyPlus-caf40fc042e24afc5403dafeffe1b016.png";